import React from 'react';
import { Icon } from './Icon.js';
export const IconShieldFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m10.536,1.807L6.286.057c-.183-.075-.389-.075-.571,0L1.464,1.807c-.281.116-.464.39-.464.693v4.969c0,2.676,3.479,4.085,4.543,4.453.15.052.304.079.458.079.153,0,.306-.026.453-.078,1.066-.368,4.546-1.778,4.546-4.454V2.5c0-.304-.184-.578-.464-.693Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconShieldFill12.js.map